import { DetailFactory, DetailOptions } from '../types/grid';
import { GridRef } from '../types/refs';



export function detail<TMaster extends object, TDetail extends object>(
  ref: GridRef<TMaster>,
  factory: DetailFactory<TMaster, TDetail>,
  options?: DetailOptions<TMaster, TDetail>
): void {
  ref.createDetail(factory, options);
}
